import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { formatFirstLastName } from "../utils/utils";
import { getTomadores, getUtilizadores } from "../services/Contacts";
import { styles } from "../styles/AddParticipantModal.styles"; 
import {FaUserPlus,FaCheck } from "react-icons/fa";


function AddParticipantModal({ isOpen, onClose, participants, isMobile,socket,onAddSelected, conversationData }) {
  const [selected, setSelected] = useState([]);
  const conversationId = conversationData?.STAMP;
  const { token, stampTomador } = useAuth(); 
  const [tomadores, setTomadores] = useState([]);
  const [utilizadores, setUtilizadores] = useState([]);
  const [tipoSelecionado, setTipoSelecionado] = useState("Todos");
  const [search, setSearch] = useState("");
  const [limit] = useState(20);
  const [loadingUtilizadores, setLoadingUtilizadores] = useState(false);
  const [beforeUtilizadores, setBeforeUtilizadores] = useState(null);
  const [hasMoreUtilizadores, setHasMoreUtilizadores] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadingTomadores, setLoadingTomadores] = useState(false);
  const [beforeTomadores, setBeforeTomadores] = useState(null);
  const [hasMoreTomadores, setHasMoreTomadores] = useState(true);
  const [loadingMoreTomadores, setLoadingMoreTomadores] = useState(false);



  const fetchTomadores = async (reset = false) => {
  try {
    if (reset) {
      setLoadingTomadores(true);
      setBeforeTomadores(null);
      setHasMoreTomadores(true);
      setTomadores([]);
    } else {
      setLoadingMoreTomadores(true);
    }

   const data = await getTomadores(
    conversationId,
    limit,
    reset ? null : beforeTomadores,
    search   // 👈 NOVO
  );

    const newItems = Array.isArray(data?.tomadores)
      ? data.tomadores
      : [];

    setTomadores((prev) => {
      const merged = reset ? newItems : [...prev, ...newItems];

      const map = new Map();
      for (const t of merged) {
        if (!t?.STAMP) continue;
        map.set(t.STAMP, t);
      }

      return Array.from(map.values());
    });

    
    setHasMoreTomadores(data?.hasMore ?? false);

  
    if (data?.nextCursor) {
      setBeforeTomadores({
        nome: data.nextCursor.nome,
        stamp: data.nextCursor.stamp,
      });
    }

  } catch (err) {
    console.error("Erro tomadores:", err);
  } finally {
    setLoadingTomadores(false);
    setLoadingMoreTomadores(false);
  }
};

const fetchUtilizadores = async (reset = false) => {
  try {
    if (reset) {
      setLoadingUtilizadores(true);
      setBeforeUtilizadores(null);
      setHasMoreUtilizadores(true);
      setUtilizadores([]);
    } else {
      setLoadingMore(true);
    }

    const data = await getUtilizadores(
      conversationId,
      limit,
      reset ? null : beforeUtilizadores,
      search 
    );

    const newItems = Array.isArray(data?.utilizadores)
      ? data.utilizadores
      : [];

    setUtilizadores((prev) => {
      const merged = reset ? newItems : [...prev, ...newItems];

      const map = new Map();
      for (const u of merged) {
        if (!u?.STAMP) continue;
        map.set(u.STAMP, u);
      }

      return Array.from(map.values());
    });

    setHasMoreUtilizadores(data?.hasMore ?? false);

   
    if (data?.nextCursor) {
      setBeforeUtilizadores({
        nome: data.nextCursor.nome,
        stamp: data.nextCursor.stamp,
      });
    }

  } catch (err) {
    console.error("Erro utilizadores:", err);
  } finally {
    setLoadingUtilizadores(false);
    setLoadingMore(false);
  }
};

  useEffect(() => {
    if (!token || !conversationId) return;

    setTomadores([]);
    setUtilizadores([]);

    setBeforeTomadores(null);
    setBeforeUtilizadores(null);

    setHasMoreTomadores(true);
    setHasMoreUtilizadores(true);

    fetchTomadores(true);
    fetchUtilizadores(true);

  }, [search]);

  const handleScroll = (e) => {
      const el = e.target;

      if (
        el.scrollTop + el.clientHeight >= el.scrollHeight - 20 &&
        hasMoreUtilizadores &&
        !loadingMore
      ) {
        fetchUtilizadores(false);
      }
  }; 
  
  const handleScrollTomadores = (e) => {
      const el = e.target;

      if (
        el.scrollTop + el.clientHeight >= el.scrollHeight - 20 &&
        hasMoreTomadores &&
        !loadingMoreTomadores
      ) {
        fetchTomadores(false);
      }
  };


  useEffect(() => {
    if (!token || !conversationId) return;

    fetchTomadores(true);
    fetchUtilizadores(true);
    
  }, [token, conversationId,participants]);

  if (!isOpen) return null;

  const toggleSelect = (stamp) => {
    setSelected((prev) =>
      prev.includes(stamp) ? prev.filter((s) => s !== stamp) : [...prev, stamp]
    );
  };

  const handleAdd = () => {
        if (!selected || selected.length === 0) return;

        const participantesToAdd = selected.map((stamp) => {
            const tomador = tomadores.find((t) => t.STAMP === stamp);
            if (tomador) return { STAMP: tomador.STAMP, TIPO: "TM" };

            const utilizador = utilizadores.find((u) => u.STAMP === stamp);
            if (utilizador) return { STAMP: utilizador.STAMP, TIPO: "UTL" };

            return null;
        }).filter(Boolean);

        

        if (socket && participantesToAdd.length > 0) {
            socket.emit("addParticipants", {
            chatstp: conversationId,
            PARTICIPANTES: participantesToAdd,
            });
          }

        setSelected([]);
        onClose();
    };


  // filtra itens pelo search
  const filteredUtilizadores = utilizadores.filter((u) =>
    u.NOME.toLowerCase().includes(search.toLowerCase())
  );

  const filteredTomadores = tomadores.filter((t) =>
    formatFirstLastName(t.NOME).toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal(isMobile)} onClick={(e) => e.stopPropagation()}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <div
              style={{
                width: 30,
                height: 30,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgb(224, 224, 224)",
                borderRadius: "50%",
              }}
            >
              <FaUserPlus size={isMobile ? 16 : 20} color="rgb(31, 58, 112)" />
            </div>
            <h3 >Adicionar Membro</h3>
          </div>

          <button onClick={onClose} style={{ ...styles.closeButton, fontSize: 18, border: "none", background: "transparent", cursor: "pointer" }}>
            ✕
          </button>
        </div>

        <div style={styles.typeSelectorContainer}>
          <label style={{ fontWeight: "bold" }}>Tipo:</label>
          <select
            value={tipoSelecionado}
            onChange={(e) => setTipoSelecionado(e.target.value)}
            style={styles.typeSelector}
          >
            <option value="Todos">Todos</option>
            <option value="Utilizadores">Utilizadores</option>
            <option value="Tomadores">Tomadores</option>
          </select>
        </div>

       
         <div style={styles.searchContainer(isMobile)}>
                <input
                  type="text"
                  placeholder="Pesquisar nome..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={styles.input(isMobile)}
                />
                <svg style={styles.svg(isMobile)} viewBox="0 0 24 24">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                </svg>
          </div>

        {/* Lista de Utilizadores */}
        {(tipoSelecionado === "Todos" || tipoSelecionado === "Utilizadores") && (
          <div>
            <h4 style={styles.sectionTitle}>Utilizadores</h4>
            <div style={styles.listContainer} onScroll={handleScroll}>
              {filteredUtilizadores.map((u, i) => (
                <div key={u.STAMP} style={styles.listItem}>
                  <div style={styles.listItemLeft}>
                    <span>{u.NOME}</span>
                  </div>
                  <button
                    onClick={() => toggleSelect(u.STAMP)}
                    style={styles.button(false)}
                  >
                    {selected.includes(u.STAMP) ? "Selecionado" : "Adicionar"}
                  </button>
                </div>
              ))}
       
              {loadingMore && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div style={styles.spinner} />
                </div>
              )}
            </div>
          </div>
        )}

        {/* Lista de Tomadores */}
        {(tipoSelecionado === "Todos" || tipoSelecionado === "Tomadores") && (
          <div>
            <h4 style={styles.sectionTitle}>Tomadores</h4>
            <div style={styles.listContainer} onScroll={handleScrollTomadores}>
              {filteredTomadores.map((t, i) => (
                <div key={`${t.STAMP || "tomador"}-${i}`} style={styles.listItem}>
                  <div style={styles.listItemLeft}>
                     <span>{formatFirstLastName(t.NOME)}</span>
                  </div>
                  <button
                    onClick={() => toggleSelect(t.STAMP)}
                    style={styles.button(false)}
                  >
                    {selected.includes(t.STAMP) ? "Selecionado" : "Adicionar"}
                  </button>
                </div>
              ))}
              {loadingMoreTomadores && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div style={styles.spinner} />
                </div>
              )}
            </div>
          </div>
        )}

        {/* Botões de ação */}
        <div style={styles.actionButtons}>
         <button onClick={handleAdd} style={styles.button(true)}>
          <FaCheck style={{ marginRight: 6 }} /> {/* Ícone antes do texto */}
          Adicionar selecionados
        </button>
        </div>
      </div>
    </div>
  );
}

export default AddParticipantModal;